import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { useEffect as b } from "react";
import i from "./index10.js";
import { IconCancel as y, IconCrop as M } from "@bynder/icons";
import { token as o, textStyles as S, ModalBase as c, Inspector as g, Flex as p, Thumbnail as k, Button as A } from "@bynder/design-system";
import { useTranslate as v, Translate as l } from "@bynder/localization";
import { CropperSection as w } from "./index13.js";
import { ControlSection as $ } from "./index14.js";
import { useCropProperties as D, useAspectProperties as H, useImageCropperActions as j } from "./index15.js";
import { transformUrlParamsToCropParams as N, transformCropParamsToUrlParams as _ } from "./index6.js";
import { Aspect as B } from "./index5.js";
const tr = ({
  src: e,
  isOpen: m,
  onClose: n,
  onSuccess: s,
  aspectRatio: C = B.CUSTOM,
  title: T
}) => {
  const { translate: I } = v(), E = D(), { aspect: L } = H(), { setImage: O, setCrop: h, setAspect: f, resetStore: x } = j(), u = C !== "custom";
  b(() => {
    if (!e)
      return;
    const a = new Image(), d = N(e);
    a.onload = () => {
      if (O({
        width: a.naturalWidth,
        height: a.naturalHeight,
        src: e,
        unit: "px"
      }), d) {
        h(d), f({
          aspect: d.aspect,
          isLocked: u
        });
        return;
      }
      h({
        height: 100,
        width: 100,
        x: 0,
        y: 0,
        unit: "%"
      }), f({ aspect: C, isLocked: u }, !0);
    }, a.src = e;
  }, [e, m]);
  const R = () => {
    s == null || s(_(e, E, L)), n();
  };
  return /* @__PURE__ */ t(
    c,
    {
      isOpen: m,
      onClose: n,
      size: "fullscreen",
      onCloseAnimationEnd: () => x(),
      children: [
        /* @__PURE__ */ r(
          c.Header,
          {
            title: T || I("CROPPER_MODAL.HEADER.TITLE")
          }
        ),
        /* @__PURE__ */ r(F, { children: /* @__PURE__ */ t(g, { children: [
          /* @__PURE__ */ r(U, { children: /* @__PURE__ */ t(p, { justifyContent: "space-between", children: [
            /* @__PURE__ */ t(p, { gap: "4", alignItems: "center", children: [
              /* @__PURE__ */ r(k, { icon: /* @__PURE__ */ r(V, {}) }),
              /* @__PURE__ */ r(z, { children: /* @__PURE__ */ r(l, { id: "CROPPER_MODAL.INSPECTOR.TITLE" }) })
            ] }),
            /* @__PURE__ */ r(A, { variant: "clean", onClick: n, children: /* @__PURE__ */ r(y, {}) })
          ] }) }),
          /* @__PURE__ */ r($, {}),
          /* @__PURE__ */ r(g.Footer, { children: /* @__PURE__ */ t(p, { direction: "row", justifyContent: "center", gap: "5", children: [
            /* @__PURE__ */ r(P, { variant: "clean", onClick: n, children: /* @__PURE__ */ r(l, { id: "CROPPER_MODAL.ACTIONS.CANCEL" }) }),
            /* @__PURE__ */ r(P, { variant: "primary", onClick: R, children: /* @__PURE__ */ r(l, { id: "CROPPER_MODAL.ACTIONS.SAVE" }) })
          ] }) })
        ] }) }),
        /* @__PURE__ */ r(c.Content, { children: /* @__PURE__ */ r(w, {}) })
      ]
    }
  );
}, F = i.div`
  grid-area: sidebar / sidebar / sidebar / sidebar;
  grid-column: none;
  z-index: 1;
  border-radius: 0 ${o.radiusLarge} ${o.radiusLarge} 0;
  overflow: hidden;
`, U = i.div`
  padding: ${o.spacing5} ${o.spacing6};
`, z = i.div`
  ${S.uiTextM}
`, P = i(A)`
  width: 136px;
`, V = i(M)`
  color: ${o.gray500};
`;
export {
  tr as CropperModal
};
